
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/retail",
      function () {
        return require("private-next-pages/use-cases/retail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/retail"])
      });
    }
  